// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineMessage_container__1LMIg","header":"OfflineMessage_header__hPmYC"};